module.exports = __webpack_public_path__ + "media/images/icon-svg/icon-settings-527b874c0c1a3295e7a91a2f6059b3e4.svg";